import type { FC, ReactNode } from "react"

// Sized in cqw so the tiles keep their proportions at every column width.
export const ArticleCoverArt: FC<{
	/** Any CSS colour, e.g. `#4CB782` or `var(--portal-accent-color)`. */
	accent: string
	logoUrl: string | null | undefined
	workspaceName: string | null | undefined
	/** The article icon, drawn in currentColor (white) at full tile size. */
	icon: ReactNode
	className?: string
}> = ({ accent, logoUrl, workspaceName, icon, className }) => {
	const initial = workspaceName?.trim().charAt(0).toUpperCase()
	return (
		<div
			aria-hidden
			data-default-article-cover=""
			className={`relative flex aspect-[1200/630] w-full items-center justify-center overflow-hidden rounded-lg [container-type:inline-size] ${className ?? ""}`}
			style={{
				backgroundColor: accent,
				backgroundImage:
					"radial-gradient(rgba(255,255,255,0.18) 1px, transparent 1px)",
				backgroundSize: "2cqw 2cqw",
			}}
		>
			<div className="flex size-[18.3cqw] -rotate-[7deg] items-center justify-center rounded-[4.7cqw] bg-white">
				{logoUrl ? (
					<img
						src={logoUrl}
						alt=""
						data-cover-logo=""
						className="size-[10.3cqw] rounded-[2.5cqw] object-contain"
					/>
				) : (
					<span
						data-cover-initial=""
						className="text-[8cqw] font-semibold"
						style={{ color: accent }}
					>
						{initial}
					</span>
				)}
			</div>
			<div
				className="-ml-[2.5cqw] flex size-[18.3cqw] rotate-[7deg] items-center justify-center rounded-[4.7cqw] border border-white/30 text-white backdrop-blur-[1.5cqw] backdrop-saturate-150 [&>*]:size-[8.2cqw]"
				style={{
					backgroundColor: `color-mix(in srgb, ${accent} 55%, rgb(0 0 0 / 0.55))`,
				}}
			>
				{icon}
			</div>
		</div>
	)
}
